import './main.scss';
const datepicker = require('js-datepicker');

//custom
let isDatepicker = document.querySelectorAll('.js-datepicker');
let i = 0;
for (i = 0; i <= isDatepicker.length; i++) {
  isDatepicker[i].classList.add('js-datepicker-' + (i + 1));
  let picker = datepicker('.js-datepicker-' + (i + 1), {
    startDay: 7,
    customDays: ['日', '一', '二', '三', '四', '五', '六'],
    customMonths: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
    overlayPlaceholder: '點選輸入年份',
    overlayButton: '確定',
    formatter: (input, date, instance) => {
      const value = date.toLocaleDateString();
      input.value = value;
    },
  })
}